import Splash from "../components/Splash";
import Login from "../components/Login/Login";
import Verify from "../components/Login/Verify";
import Register from "../components/Login/Register";
import Rules from "../components/Login/Rules";
import Home from "../components/Home/Home";
import Contents from "../components/Home/Contents";
import Wallet from "../components/Payment/Wallet";
import PersonProfile from "../components/Profile/PersonProfile";
import CompanyProfile from "../components/Profile/CompanyProfile";
import Addresses from "../components/Profile/Addresses";
import AddAddress from "../components/Profile/AddAddress";
import EditAddress from "../components/Profile/EditAddress";
import RequestsList from "../components/Requests/RequestsList";
import RequestProfile from "../components/Requests/RequestProfile";
import NewRequest from "../components/Requests/NewRequest";
import NewSmallCargoRequest from "../components/Requests/NewSmallCargoRequest";
import RateRequest from "../components/Requests/RateRequest";

const appRoutes = [
    {
        id : '0',
        path : '/',
        component : Splash
    },
    {
        id : '1',
        path : '/login',
        component : Login
    },
    {
        id : '2',
        path : '/verify',
        component : Verify
    },
    {
        id : '3',
        path : '/register',
        component : Register
    },
    {
        id : '4',
        path : '/rules',
        component : Rules
    },
    {
        id : '5',
        path : '/home',
        component : Home
    },
    {
        id : '6',
        path : '/contents/:content',
        component : Contents
    },
    {
        id : '7',
        path : '/wallet',
        component : Wallet
    },
    {
        id : '8',
        path : '/profile',
        component : PersonProfile
    },
    {
        id : '9',
        path : '/profile/company',
        component : CompanyProfile
    },
    {
        id : '10',
        path : '/profile/addresses',
        component : Addresses
    },
    {
        id : '10',
        path : '/profile/address',
        component : AddAddress
    },
    {
        id : '11',
        path : '/profile/address/:id',
        component : EditAddress
    },
    {
        id : '12',
        path : '/requests/:page',
        component : RequestsList
    },
    {
        id : '13',
        path : '/request-profile/:id',
        component : RequestProfile
    },
    {
        id : '14',
        path : '/request/new',
        component : NewRequest
    },
    {
        id : '15',
        path : '/request/new-sc',
        component : NewSmallCargoRequest
    },
    {
        id : '16',
        path : '/rate/:id',
        component : RateRequest
    },
];
export default appRoutes;